import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {ScrollArea} from '@/components/ui/scroll-area/ScrollArea'
import styled, {css} from 'styled-components'

export const StyledTreatmentRequestFollowUpsTop = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 4}px ${spacing * 6}px;
    `
)

export const StyledFollowUpsScrollArea = styled(ScrollArea)`
    height: 100%;
`

export const StyledTreatmentRequestFollowUpsContent = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        height: 100%;
        max-height: 400px;
        padding: 0 ${spacing * 6}px;

        & > div:first-child {
            padding-top: ${spacing * 1.5}px;
        }

        & > div:last-child {
            padding-bottom: ${spacing * 3}px;
        }
    `
)

export const StyledEmptyFollowUpsLabel = styled.p(
    ({theme: {typography, palette}}) => css`
        ${typography.textMd};
        color: ${palette.neutral['600']};
    `
)
